export default __webpack_public_path__ + "static/jeffrey-atkisson-cf9403668bba68504c4843f6491b6034.png";